module.exports = __webpack_public_path__ + "static/img/northFace4.825e93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/northFace4.png
// module id = Mm8y
// module chunks = 2